import { isActiveDiscountOriginal } from "utility/conditionalTicket";

import type { PurchaseTicketData } from "modules/ticket";

type GetDisplayEventTicketsParams = {
  tickets: PurchaseTicketData[];
  isAdmin: boolean;
  nowTimestamp: number;
};

export const getDisplayEventTickets = ({
  tickets,
  isAdmin,
  nowTimestamp,
}: GetDisplayEventTicketsParams): PurchaseTicketData[] =>
  tickets
    .filter(
      (ticket) =>
        (ticket.display &&
          ticket.saleType !== "liveCommerceOnly" &&
          ticket.releaseDateTime / 1000 <= nowTimestamp &&
          nowTimestamp < ticket.closeDateTime / 1000) ||
        isAdmin
    )
    // 割引が有効なユーザーには割引もと(通常チケット)を非表示にする。
    // 表示対象に絞り込んだ後段で判定するため、isAdmin でも割引もとは非表示になる。
    .filter(
      (ticket, _index, displayTickets) =>
        !isActiveDiscountOriginal(ticket, displayTickets)
    )
    .sort(
      (previousTicket, currentTicket) =>
        previousTicket.priority - currentTicket.priority
    );
